import { NgModule } from "@angular/core";
import { CoreModule as CoreCommonModule } from "common";
import { NavigationService } from "./navigation/navigation.service";
import { IsApplicationsOfferVisiblePipe } from "../shared/pipes/is-applications-offer-visible.pipe";

@NgModule({
  imports: [CoreCommonModule],
  providers: [
    NavigationService,
    IsApplicationsOfferVisiblePipe
  ],
})
export class CoreModule {
  constructor(navigationService: NavigationService) {
    navigationService.handleQueryParamDuringEachNavigation();
  }
}
